<template>
  <div class="mobile">
    <div class="container">
      <div class="header">
        <transition
          name="showAnimatMenu"
          enter-active-class="animated fadeInRight"
          leave-active-class="animated fadeOutRight"
        >
          <div class="background_menu" v-if="show">
            <div class="header__btn__nav_container">
              <a class="menu__logo_container" href="/">
                <img src="@/img/menu_logo.png" alt="" class="header__logo" />
              </a>
              <div class="header__select_block">
                <div class="bg-lang" v-if="showLang"></div>
                <div
                  class="header__select"
                  @click="showLang = !showLang"
                  :class="{ clouse: !showLang }"
                >
                  <span class="name_lang">{{ languegeAbr }}</span>
                  <span class="icon_lang"
                    ><i class="fas fa-angle-down"></i
                  ></span>
                </div>
                <transition
                  name="showAnimat"
                  enter-active-class="animated fadeIn"
                  leave-active-class="animated fadeOut"
                >
                  <div
                    class="header__select__group"
                    :data-lang="`${lang}`"
                    v-if="showLang"
                  >
                    <a
                      :href="`/${item.titleBurgerIdCountry.toLowerCase()}/`"
                      v-for="item in langueges"
                      :key="item.index"
                      class="header__select"
                      @click="newLang(item)"
                      >{{ item.titleBurgerLang }}</a
                    >
                  </div>
                </transition>
              </div>
              <div class="header__btn__nav_block" v-if="show">
                <button
                  @click="closedMenu(), perehod(burger_url[i])"
                  v-for="(value, i) in burger_name"
                  :key="value.id"
                  class="header__btn__nav"
                >
                  {{ value }}
                </button>
              </div>
              <div class="footer__socicon_block">
                <div class="footer__socicon__container">
                  <a
                    :href="socIcon.textUrl"
                    class="footer__socicon"
                    target="_blank"
                    v-for="socIcon in footerSocicon"
                    :key="socIcon.id"
                  >
                    <i :class="socIcon.textClass"></i>
                  </a>
                </div>
                <div class="copiright">{{ footerCopyright.textCopyright }}</div>
                <a
                  href="https://kruchenas.net/"
                  class="footer__kruche"
                  target="_blank"
                >
                  <span>
                    <a href="https://kruchenas.net/" target="_blank"
                      >kruchenas.net</a
                    >
                    - <span v-html="footerCopyright.textKruche"></span>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </transition>
        <div class="header__left">
          <a class="header__logo_container" href="/">
            <img src="@/img/logo.png" alt="" class="header__logo" />
          </a>
        </div>
        <div class="header__right">
          <div class="burger" @click="openMenu" :class="{ open: show }">
            <span class="burger__line"></span>
            <span class="burger__line burger__line--hidden"></span>
            <span class="burger__line"></span>
          </div>
        </div>
      </div>
      <div
        class="starter"
        :style="{ 'background-image': 'url(' + starterScreen.starterBack }"
      >
        <div class="starter__container">
          <h1 class="starter__title" v-html="starterScreen.starterTitle"></h1>
          <p class="starter__text" v-html="starterScreen.starterText"></p>
          <img
            :src="starterScreen.starterImage"
            alt=""
            class="starter__image"
            @click="transitionToCookies"
          />
<!--          <img-->
<!--            class="footer__socicon__img"-->
<!--            :src="starterScreen.footerSociconImg"-->
<!--            alt=""-->
<!--          />-->
            <ModalWindowMarket/>
            <MarketButtonMobile class="mobile__start_footer_block_button"/>
        </div>
      </div>
            <div class="cookies__container one">
        <div class="swiper-container--cookies swiper-container">
          <div class="cookies__cart_container swiper-wrapper">
            <div
              class="cookies_swiper-slide swiper-slide"
              v-for="item in allCookies"
              :key="item.id"
            >
              <canvas
                class="cookies"
                :data-text="item.text"
                ref="tester"
                @click="targetCooki"
              >
              </canvas>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
        <div
          v-for="item in allCookies"
          :key="item.id"
          class="cookies__prediction"
          ref="prediction"
        >
          <canvas class="cookies__prediction__paper"></canvas>
          <p v-if="popapShow" v-html="item.text"></p>
        </div>
        <transition
          name="showAnimat"
          enter-active-class="animated fadeIn"
          leave-active-class="animated fadeOut"
        >
          <div class="popap" v-if="popapShow">
            <div class="popap__bg" @click="popapAnShow"></div>
            <div class="popap__container">
              <div class="closed" @click="popapAnShow">
                <i class="fas fa-times"></i>
              </div>
              <div class="popap__text"></div>
              <!-- <div class="popap__line"></div> -->
              <div class="popap__share">
                <p class="popap__share__text">{{ titleShare }}</p>
                <div class="popap__share__icon_container">
                  <div
                    class="popap__share__icon"
                    @click="shared(item.socialUrl)"
                    v-for="item in social"
                    :key="item.id"
                  >
                    <i :class="item.socialClass"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
        <button class="cookies__btn" @click="coociesBtnBoom">
          {{ btnTakeMob }}
        </button>
      </div>
      <div class="product two">
        <div class="product_container container">
          <div class="product__left">
            <p class="product__sub-title">{{ product.cookingMethodTitle }}</p>
            <ul class="product__item">
              <li
                class="product__list"
                v-for="(item, index) in product.cookingMethod"
                :key="item.id"
              >
                <img :src="item.img" alt />
                <span class="number">{{ index + 1 }}.</span>
                <span v-html="item.text"></span>
              </li>
            </ul>
          </div>
          <div>
          </div>
          <div class="product__right">
            <ModalWindowMarket/>
            <div class="product__big-photo">
              <div class="product_swiper-container swiper-container">
                <div class="product__cart_container swiper-wrapper">
                  <div
                    class="product__cart swiper-slide"
                    v-for="product in product.assortimentMobile"
                    :key="product.id_m"
                  >
                    <img
                      :src="product.imgProduct"
                      alt=""
                      class="product__cart__background"
                    />
                    <div class="mobile__block_button">
                      <p class="product__title" v-html="productTitle"></p>
                    </div>
                    <div>
                      <p
                          class="product__sub_title"
                          v-html="product.nameProduct"
                      >
                      </p>
                    </div>
                    <p
                      class="product__sub_title last"
                      v-html="product.flavorProduct"
                    >
                    </p>
                    <div class="product__descriptoin_box " 
                      @click="moreDescr" :class="{'product__descriptoin_more': !isMoreDescr}">
                      <p
                        class="product__descriptoin "
                        v-html="product.textProduct"

                      >

                       </p>
                      <MarketButtonMobile class="product__sub-title_button"/>
                      <span class="btn-more">
                          <i class="fas fa-angle-down"></i>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="swiper-pagination"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="recipes">
        <div class="container">
          <h2 class="recipes__title">
            {{ recipesTitle }}
          </h2>
        </div>
        <div class="swiper-container">
          <div class="recipes__cart_container swiper-wrapper">
            <div
              class="recipes__cart swiper-slide"
              v-for="(recip, index) in recipes"
              :key="recip.id"
              ref="recipesCart"
              @click="
                recipPopapInfoCard(recip.imges, recip.title, recip.text, index)
              "
            >
              <img
                :src="recip.imges"
                alt=""
                class="recipes__cart__background"
              />
              <!-- <p class="recipes__cart__data">{{recip.date}}</p> -->
              <h3 class="recipes__cart__header" v-html="recip.title"></h3>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
      <div class="news">
        <div class="container">
          <h2 class="news__title">
            {{ newsTitle }}
          </h2>
        </div>
        <div class="swiper-container--news">
          <div class="news__cart_container swiper-wrapper">
            <div
              class="news__cart swiper-slide"
              v-for="(item, index) in news"
              :key="item.id"
              ref="newsCart"
              @click="
                newsPopapInfoCard(item.imges, item.title, item.text, index)
              "
            >
              <div class="news__cart__img_block">
                <img :src="item.imges" alt="" class="news__cart__img" />
              </div>
              <div class="news__cart__block">
                <h3 class="news__cart__header">{{ item.title }}</h3>
                <p class="news__cart__data">{{ item.date }}</p>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
      <div class="prelast">
        <div class="container">
          <div
            class="prelast__card_container"
            v-for="(info, index) in information"
            :key="info.id"
            @click="popapActive(index)"
          >
            <h2 class="prelast__title">{{ info.title }}</h2>
            <p class="prelast__text">{{ info.cardText }}</p>
            <div class="arrow-prelast"><i class="fas fa-angle-right"></i></div>
            <img :src="info.img" alt="" class="prelast__img" />
          </div>
        </div>
      </div>
      <!-- <div class="score">
                <div class="container">
                    <h2 class="score__title">
                        {{scoreTitle}}
                    </h2>                    
                </div>
                <div class="swiper-container--score">
                    <div class="score__cart_container swiper-wrapper">
                        <div class="score__cart swiper-slide" v-for="score in scores" :key="score.id">
                            <div class="score__item__img_block">
                                <img :src="score.img" :alt="score.title" class="score__item__img">
                            </div>
                            <h3 class="score__item__name">{{score.title}}</h3>
                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                    <div class="arrow-block arrow-block--score">
                        <div class="swiper-button-prev arrow-slide arrow-slide_left"> <i class="fas fa-angle-left"></i></div>
                        <div class="swiper-button-next arrow-slide arrow-slide_right"><i class="fas fa-angle-right"></i></div>
                    </div>
                </div>
            </div> -->
      <transition
        name="showAnimat"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <div
          class="new_popap"
          v-if="recipesPopapShow"
          v-touch:swipe.left="prevContentRecipes"
          v-touch:swipe.right="nextContentRecipes"
        >
          <div class="new_popap__bg" @click="closePopupRecip"></div>
          <div class="new_popap__container">
            <div class="new_closed" @click="closePopupRecip">
              <i class="fas fa-times"></i>
            </div>
            <h2 class="new_popap__head" v-html="headPopap"></h2>
            <div class="new_popap__info">
              <img :src="imgPopap" alt="" />
              <div class="new_popap__text" v-html="textPopap"></div>
              <div class="shadow_block__container landscape">
                <div class="new_popap__text" v-html="textPopap"></div>
                <div class="shadow_block"></div>
              </div>
            </div>
            <div class="shadow_block"></div>
            <div class="new_popap__line"></div>
            <div class="new_popap__btn_container">
              <button
                class="new_popap__btn new_popap__btn--left"
                @click="leftRecipes"
              >
                <i class="fas fa-angle-left"></i><span>Предыдущий рецепт</span>
              </button>
              <button
                class="new_popap__btn new_popap__btn--right"
                @click="rightRecipes"
              >
                <span>Следующий рецепт</span><i class="fas fa-angle-right"></i>
              </button>
            </div>
          </div>
        </div>
      </transition>
      <transition
        name="showAnimat"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <div
          class="new_popap"
          v-if="newsPopapShow"
          v-touch:swipe.left="prevContentNews"
          v-touch:swipe.right="nextContentNews"
        >
          <div class="new_popap__bg" @click="closePopupNews"></div>
          <div class="new_popap__container">
            <div class="new_closed" @click="closePopupNews">
              <i class="fas fa-times"></i>
            </div>
            <h2 class="new_popap__head" v-html="headPopap"></h2>
            <div class="new_popap__info">
              <img :src="imgPopap" alt="" />
              <div class="new_popap__text" v-html="textPopap"></div>
              <div class="shadow_block__container landscape">
                <div class="new_popap__text" v-html="textPopap"></div>
                <div class="shadow_block"></div>
              </div>
            </div>
            <div class="shadow_block"></div>
            <div class="new_popap__line"></div>
            <div class="new_popap__btn_container">
              <button
                class="new_popap__btn new_popap__btn--left"
                @click="leftNews"
              >
                <i class="fas fa-angle-left"></i><span>Предыдущая новость</span>
              </button>
              <button
                class="new_popap__btn new_popap__btn--right"
                @click="rightNews"
              >
                <span>Следующая новость</span><i class="fas fa-angle-right"></i>
              </button>
            </div>
          </div>
        </div>
      </transition>
      <transition
        name="showAnimat"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <div
          class="new_popap"
          v-if="prelastPopapShow"
          v-touch:swipe.left="prevContentPrelast"
          v-touch:swipe.right="nextContentPrelast"
        >
          <div class="new_popap__bg" @click="closePopupPrelast"></div>
          <div class="new_popap__container">
            <div class="new_closed" @click="closePopupPrelast">
              <i class="fas fa-times"></i>
            </div>
            <h2 class="new_popap__head" v-html="headPopap"></h2>
            <div class="new_popap__info">
              <img :src="imgPopap" alt="" />
              <div class="new_popap__text" v-html="textPopap"></div>
              <div class="shadow_block__container landscape">
                <div class="new_popap__text" v-html="textPopap"></div>
                <div class="shadow_block"></div>
              </div>
            </div>
            <div class="shadow_block"></div>
            <div class="new_popap__line"></div>
            <div class="new_popap__btn_container">
              <button
                class="new_popap__btn new_popap__btn--left"
                @click="leftPrelast"
              >
                <i class="fas fa-angle-left"></i><span>{{ prePopap }}</span>
              </button>
              <button
                class="new_popap__btn new_popap__btn--right"
                @click="rightPrelast"
              >
                <span>{{ lastPopap }}</span
                ><i class="fas fa-angle-right"></i>
              </button>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swiper from "swiper";
import "swiper/js/swiper.js";
import { HTTP, Routes } from "../API";
import MarketButtonMobile from "@/components/Buttons/MarketButtonMobile";
import ModalWindowMarket from "@/components/Buttons/ModalWindowMarket";

export default {
  name: "Mobile",
  components: {ModalWindowMarket, MarketButtonMobile},
  data: () => ({
    isVisibilityButton: true,
    direction: null,
    show: false,
    popapShow: false,
    footerSocicon: [],
    footerCopyright: [],
    starterScreen: [],
    titleDiscription: "",
    titlePage: "",
    allCookies: [],
    activeIndex: 0,
    animateCookies: [
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_00.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_01.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_02.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_03.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_04.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_05.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_06.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_07.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_08.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_09.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_10.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_11.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_12.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_13.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_14.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_15.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_16.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_17.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_18.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_19.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_20.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_21.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_22.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_23.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_24.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_25.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_26.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_27.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_28.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_29.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_30.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_31.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_32.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_33.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_34.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_35.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_36.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_37.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_38.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_39.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_40.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_41.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_42.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_43.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_44.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_45.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_46.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_47.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_48.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_49.png"),
      },
      {
        images: require("@/img/Cookie_1/Cookie_1_resize_50.png"),
      },
    ],
    cookieSekvencia: [
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_20.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_21.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_22.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_23.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_24.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_25.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_26.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_27.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_28.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_29.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_30.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_31.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_32.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_33.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_34.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_35.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_36.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_37.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_38.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_39.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_40.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_41.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_42.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_43.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_44.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_45.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_46.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_47.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_48.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_49.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_50.png"),
      },
            {
        images: require("@/img/CookieCrush_27.05/CookieCrush_51.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_52.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_53.png"),
      },
      {
        images: require("@/img/CookieCrush_27.05/CookieCrush_54.png"),
      },

    ],
    paperSekvencia: [
      {
        images: require("@/img/Paper/Paper_1_00.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_01.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_02.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_03.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_04.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_05.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_06.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_07.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_08.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_09.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_10.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_11.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_12.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_13.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_14.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_15.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_16.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_17.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_18.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_19.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_20.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_21.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_22.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_23.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_24.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_25.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_26.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_27.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_28.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_29.png"),
      },
      {
        images: require("@/img/Paper/Paper_1_30.png"),
      },
    ],
    activeSlide: 0,
    social: [],
    deleteAnimation: true,
    burger_name: [],
    swiperCookies: null,
    product: [],
    bigSrc: "",

    recipesTitle: "",
    recipes: [],
    recipesPopapShow: false,
    indexRecipes: 0,
    newsTitle: "",
    news: [],
    newsPopapShow: false,
    indexNews: 0,

    information: [],
    prelastPopapShow: false,
    prePopap: "",
    lastPopap: "",
    indexInformation: 0,

    textPopap: "",
    headPopap: "",
    imgPopap: "",

    scoreTitle: "",
    scores: [],
    cookieActive: false,
    showLang: false,
    langueges: [],
    languegeAbr: null,
    langDataHeader: null,
    currentLangueges: null,
    lang: null,
    titleShare: "",
    btnTakeMob: "",
    productTitle: "",
    isMoreDescr: false,
    cookingMethodTitle: null,
    cookingMethod: [],
  }),
  mounted: function () {
    this.getContent();
    // запрос данных
    axios.get("https://macchocolate.ru/api/api_score/").then((response) => {
      this.scores = response.data.score;

      setTimeout(() => {
        var swiperScore = new Swiper(".swiper-container--score", {
          slidesPerView: 1,
          slidesPerColumn: 5,
          spaceBetween: 10 * document.querySelector(".sizePage").dataset.number,
          navigation: {
            nextEl: ".score .swiper-button-next",
            prevEl: ".score .swiper-button-prev",
          },
          pagination: {
            el: ".score .swiper-pagination",
            clickable: true,
          },
        });
      }, 0);
    });

    setTimeout(() => {
      var Visible = (target) => {
        // Все позиции элемента
        var targetPosition = {
            top: window.pageYOffset + target.getBoundingClientRect().top,
            left: window.pageXOffset + target.getBoundingClientRect().left,
            right: window.pageXOffset + target.getBoundingClientRect().right,
            bottom: window.pageYOffset + target.getBoundingClientRect().bottom,
          },
          // Получаем позиции окна
          windowPosition = {
            top: window.pageYOffset,
            left: window.pageXOffset,
            right: window.pageXOffset + document.documentElement.clientWidth,
            bottom: window.pageYOffset + document.documentElement.clientHeight,
          };

        if (
          targetPosition.bottom > windowPosition.top &&
          // Если позиция нижней части элемента больше позиции верхней чайти окна, то элемент виден сверху
          targetPosition.top < windowPosition.bottom &&
          // Если позиция верхней части элемента меньше позиции нижней чайти окна, то элемент виден снизу
          targetPosition.right > windowPosition.left &&
          // Если позиция правой стороны элемента больше позиции левой части окна, то элемент виден слева
          targetPosition.left < windowPosition.right
        ) {
          // Если позиция левой стороны элемента меньше позиции правой чайти окна, то элемент виден справа
          // Если элемент полностью видно, то запускаем следующий код
          document
            .querySelector(".cookies__container .swiper-pagination")
            .classList.add("active");
        } else {
          // Если элемент не видно, то запускаем этот код
          document
            .querySelector(".cookies__container .swiper-pagination")
            .classList.remove("active");
        }
      };

      var Visible2 = (target) => {
        // Все позиции элемента
        var targetPosition = {
            top: window.pageYOffset + target.getBoundingClientRect().top,
            left: window.pageXOffset + target.getBoundingClientRect().left,
            right: window.pageXOffset + target.getBoundingClientRect().right,
            bottom: window.pageYOffset + target.getBoundingClientRect().bottom,
          },
          // Получаем позиции окна
          windowPosition = {
            top: window.pageYOffset,
            left: window.pageXOffset,
            right: window.pageXOffset + document.documentElement.clientWidth,
            bottom: window.pageYOffset + document.documentElement.clientHeight,
          };

        if (
          targetPosition.bottom > windowPosition.top &&
          // Если позиция нижней части элемента больше позиции верхней чайти окна, то элемент виден сверху
          targetPosition.top < windowPosition.bottom &&
          // Если позиция верхней части элемента меньше позиции нижней чайти окна, то элемент виден снизу
          targetPosition.right > windowPosition.left &&
          // Если позиция правой стороны элемента больше позиции левой части окна, то элемент виден слева
          targetPosition.left < windowPosition.right
        ) {
          // Если позиция левой стороны элемента меньше позиции правой чайти окна, то элемент виден справа
          // Если элемент полностью видно, то запускаем следующий код
          document
            .querySelector(".product .swiper-pagination")
            .classList.add("active");
        } else {
          // Если элемент не видно, то запускаем этот код
          document
            .querySelector(".product .swiper-pagination")
            .classList.remove("active");
        }
      };

      var Visible3 = (target) => {
        // Все позиции элемента
        var targetPosition = {
            top: window.pageYOffset + target.getBoundingClientRect().top,
            left: window.pageXOffset + target.getBoundingClientRect().left,
            right: window.pageXOffset + target.getBoundingClientRect().right,
            bottom: window.pageYOffset + target.getBoundingClientRect().bottom,
          },
          // Получаем позиции окна
          windowPosition = {
            top: window.pageYOffset,
            left: window.pageXOffset,
            right: window.pageXOffset + document.documentElement.clientWidth,
            bottom: window.pageYOffset + document.documentElement.clientHeight,
          };

        if (
          targetPosition.bottom > windowPosition.top &&
          // Если позиция нижней части элемента больше позиции верхней чайти окна, то элемент виден сверху
          targetPosition.top < windowPosition.bottom &&
          // Если позиция верхней части элемента меньше позиции нижней чайти окна, то элемент виден снизу
          targetPosition.right > windowPosition.left &&
          // Если позиция правой стороны элемента больше позиции левой части окна, то элемент виден слева
          targetPosition.left < windowPosition.right
        ) {
          // Если позиция левой стороны элемента меньше позиции правой чайти окна, то элемент виден справа
          // Если элемент полностью видно, то запускаем следующий код
          document
            .querySelector(".recipes .swiper-pagination")
            .classList.add("active");
        } else {
          // Если элемент не видно, то запускаем этот код
          document
            .querySelector(".recipes .swiper-pagination")
            .classList.remove("active");
        }
      };

      var Visible4 = (target) => {
        // Все позиции элемента
        var targetPosition = {
            top: window.pageYOffset + target.getBoundingClientRect().top,
            left: window.pageXOffset + target.getBoundingClientRect().left,
            right: window.pageXOffset + target.getBoundingClientRect().right,
            bottom: window.pageYOffset + target.getBoundingClientRect().bottom,
          },
          // Получаем позиции окна
          windowPosition = {
            top: window.pageYOffset,
            left: window.pageXOffset,
            right: window.pageXOffset + document.documentElement.clientWidth,
            bottom: window.pageYOffset + document.documentElement.clientHeight,
          };

        if (
          targetPosition.bottom > windowPosition.top &&
          // Если позиция нижней части элемента больше позиции верхней чайти окна, то элемент виден сверху
          targetPosition.top < windowPosition.bottom &&
          // Если позиция верхней части элемента меньше позиции нижней чайти окна, то элемент виден снизу
          targetPosition.right > windowPosition.left &&
          // Если позиция правой стороны элемента больше позиции левой части окна, то элемент виден слева
          targetPosition.left < windowPosition.right
        ) {
          // Если позиция левой стороны элемента меньше позиции правой чайти окна, то элемент виден справа
          // Если элемент полностью видно, то запускаем следующий код
          document
            .querySelector(".news .swiper-pagination")
            .classList.add("active");
        } else {
          // Если элемент не видно, то запускаем этот код
          document
            .querySelector(".news .swiper-pagination")
            .classList.remove("active");
        }
      };

      // Получаем нужный элемент
      var element = document.querySelector(".cookies__container");

      // Запускаем функцию при прокрутке страницы
      window.addEventListener("scroll", function () {
        Visible(element);
      });

      // А также запустим функцию сразу. А то вдруг, элемент изначально видно
      Visible(element);

      // Получаем нужный элемент
      var element2 = document.querySelector(".product__right");

      // Запускаем функцию при прокрутке страницы
      window.addEventListener("scroll", function () {
        Visible2(element2);
      });

      // А также запустим функцию сразу. А то вдруг, элемент изначально видно
      Visible2(element2);

      // Получаем нужный элемент
      var element3 = document.querySelector(".recipes__cart_container");

      // Запускаем функцию при прокрутке страницы
      window.addEventListener("scroll", function () {
        Visible3(element3);
      });

      // А также запустим функцию сразу. А то вдруг, элемент изначально видно
      Visible3(element3);

      // Получаем нужный элемент
      var element4 = document.querySelector(".news__cart_container");

      // Запускаем функцию при прокрутке страницы
      window.addEventListener("scroll", () => {
        Visible4(element4);
      });

      // А также запустим функцию сразу. А то вдруг, элемент изначально видно
      Visible4(element4);

      window.addEventListener("scroll", function () {
        document.querySelector(".footer__socicon__img").style.transform =
          "translateY(" + pageYOffset * -0.5 + "px)";
        document.querySelector(".header__logo_container img").style.transform =
          "translateY(" + pageYOffset * -0.5 + "px)";
      });
      document.querySelector(".footer__socicon__img").style.transform =
        "translateY(" + pageYOffset * -0.5 + "px)";
      document.querySelector(".header__logo_container img").style.transform =
        "translateY(" + pageYOffset * -0.5 + "px)";
    }, 0);
  },
  methods: {
    StartSwipeHandler (direction) {
      console.log(direction, 'StartSwipeHandler')
      this.direction = direction
    },
    StopSwipe(direction) {
      console.log(direction, 'StopSwipe')
    },
    getContent() {
      // HTTP.get(Routes.burger_menu).then((response) => {
      HTTP.get(Routes.testBurger).then((response) => {
        let respons = response.data.UserLng;
        if (localStorage.lang && localStorage.lang === respons) {
          this.lang = localStorage.lang;
        } else {
          this.lang = respons;
          localStorage.lang = this.lang;
        }

        this.langDataHeader = response.data;
        // this.burger_name = response.data[this.lang].burger_name;
        // this.burger_url = response.data[this.lang].burger_url;
        this.burger_name = response.data[this.lang].burger_name.filter(item => item);
        this.burger_url = response.data[this.lang].burger_url.filter(item => item);
        this.langueges = response.data[this.lang].burger_lang; //для списка языков
        this.currentLangueges = response.data[this.lang].burger_langTitle; //для выбранного языка
        this.languegeAbr = this.currentLangueges.titleBurgerIdCountry;
        

        HTTP.get(Routes.footer).then((response) => {
          this.footerSocicon = response.data[this.lang].footer.footerSocicon;

          this.footerCopyright =
            response.data[this.lang].footer.footerCopyright[0];
        });
        HTTP.get(Routes.video).then((response) => {
          this.starterScreen = response.data[this.lang].startScreen[0];
        });
        HTTP.get(Routes.two).then((response) => {
          this.product = response.data[this.lang];
          this.productTitle = this.product.headProduct;
          this.cookingMethodTitle = this.product.cookingMethodTitle,
          this.cookingMethod = this.product.cookingMethod

          setTimeout(() => {
            var recipesSwiper = new Swiper(".product_swiper-container", {
              slidesPerView: 1,
              // autoHeight: true,
              spaceBetween:
                20 * document.querySelector(".sizePage").dataset.number,
              pagination: {
                el: ".product .swiper-pagination",
                clickable: true,
              },
            });
          }, 0);
        });
        HTTP.get(Routes.one_social).then((response) => {
          this.social = response.data[this.lang].socialShare;
        });
        HTTP.get(Routes.one_cookies).then((response) => {
          this.allCookies = response.data[this.lang].cookies;
          this.allCookies = this.allCookies.splice(0, 10);
          this.titleDiscription = response.data[this.lang].titleDiscription;
          this.titlePage = response.data[this.lang].titlePage;
          this.btnTakeMob = response.data[this.lang].btnTake;
          this.titleShare = response.data[this.lang].titleS;

          setTimeout(() => {
            for (
              let i = 0;
              document.querySelectorAll(".cookies").length > i;
              i++
            ) {
              setTimeout(() => {
                let imgСookies = new Image();
                // Канвас для печенек

                let canvasСookies = document.querySelectorAll(".cookies")[i];
                let ctxСookies = canvasСookies.getContext("2d");

                canvasСookies.width =
                  150 * document.querySelector(".sizePage").dataset.number;
                canvasСookies.height =
                  150 * document.querySelector(".sizePage").dataset.number;

                let numberRandom = Math.floor(
                  -50 + Math.random() * (50 + 1 - -50)
                );

                document.querySelectorAll(".cookies")[i].style.opacity = "1";
                document.querySelectorAll(".cookies")[i].style.transform =
                  "translateY(" + numberRandom + "rem)";
                // Рандомное покачивание печенья
                // if (this.deleteAnimation) {
                canvasСookies.width = document.querySelectorAll(".cookies")[
                  i
                ].offsetWidth;
                canvasСookies.height = document.querySelectorAll(".cookies")[
                  i
                ].offsetHeight;

                this.initCanvasСookies(
                  this.allCookies[i].images,
                  canvasСookies,
                  ctxСookies,
                  imgСookies
                );

                let numShow = 0;
                let intervalPokach = () => {
                  if (
                    numShow < this.animateCookies.length - 1 &&
                    this.deleteAnimation
                  ) {
                    numShow++;
                    imgСookies.src = this.animateCookies[numShow].images;
                    imgСookies.onload = function () {
                      ctxСookies.clearRect(
                        0,
                        0,
                        canvasСookies.width,
                        canvasСookies.height
                      );
                      ctxСookies.drawImage(
                        imgСookies,
                        0,
                        0,
                        canvasСookies.width,
                        canvasСookies.height
                      );
                      setTimeout(intervalPokach, 35);
                    };
                  } else if (!this.deleteAnimation) {
                    // imgСookies.src = this.cookieSekvencia[this.cookieSekvencia.length - 1].images
                    // imgСookies.onload = function() {
                    //     ctxСookies.clearRect(0, 0, canvasСookies.width, canvasСookies.height);
                    //     ctxСookies.drawImage(imgСookies, 0, 0, canvasСookies.width, canvasСookies.height)
                    // }
                    setTimeout(intervalPokach, 1500);
                  } else {
                    numShow = 0;
                    setTimeout(intervalPokach, 35);
                  }
                };
                intervalPokach();
                // }
              }, 300 * i);
            }
            let widthSwiper =
              window.innerWidth -
              32 * document.querySelector(".sizePage").dataset.number;
            let marginSwiper = (window.innerWidth / 3) * -1;
            let marginSwiperIos = window.innerWidth / 2;

            if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
              this.swiperCookies = new Swiper(".swiper-container--cookies", {
                slidesPerView: 2,
                spaceBetween: marginSwiperIos,
                centeredSlides: true,
                width: widthSwiper,
                speed: 300,
                observer: true,
                initialSlide: 2,
                pagination: {
                  el: ".cookies__container .swiper-pagination",
                  clickable: true,
                },
              });
            } else {
              this.swiperCookies = new Swiper(".swiper-container--cookies", {
                slidesPerView: 1,
                spaceBetween: marginSwiper,
                centeredSlides: true,
                width: widthSwiper,
                speed: 300,
                observer: true,
                initialSlide: 2,
                pagination: {
                  el: ".cookies__container .swiper-pagination",
                  clickable: true,
                },
              });
            }

            this.swiperCookies.on("slideChange", () => {
              this.activeSlide = this.swiperCookies.realIndex;
            });
          }, 0);
        });
        HTTP.get(Routes.recipes).then((response) => {
          this.recipes = response.data[this.lang].recipes;
          this.recipesTitle = response.data[this.lang].titleScreen;

          setTimeout(() => {
            var recipesSwiper = new Swiper(".recipes .swiper-container", {
              slidesPerView: 1,
              spaceBetween:
                10 * document.querySelector(".sizePage").dataset.number,
              pagination: {
                el: ".recipes .swiper-pagination",
                clickable: true,
              },
            });
          }, 0);
        });
        HTTP.get(Routes.news).then((response) => {
          this.news = response.data[this.lang].news;
          this.newsTitle = response.data[this.lang].titleScreen;

          setTimeout(() => {
            var swiperNews = new Swiper(".swiper-container--news", {
              slidesPerView: 1,
              spaceBetween:
                10 * document.querySelector(".sizePage").dataset.number,
              pagination: {
                el: ".news .swiper-pagination",
                clickable: true,
              },
            });
          }, 0);
        });
        HTTP.get(Routes.prelast).then((response) => {
          this.information = response.data[this.lang].prelast.information;
        });
      });
    },
    newLang(e) {
      localStorage.lang = e.titleBurgerCountry;
      // this.lang = e.titleBurgerCountry;
      // this.langueges = this.langDataHeader[this.lang].burger_lang
      // this.burger_name = this.langDataHeader[this.lang].burger_name
      // this.burger_url = this.langDataHeader[this.lang].burger_url

      // this.languegeAbr = e.titleBurgerIdCountry //записать аббревиатуру выбранного языка в кнопку
      // this.showLang = false //закрыть меню языков
    },
    noScroll(isPopup) {
      //для блокировки скролла без дерганья контента
      // const div = document.createElement("div");
      // div.style.overflowY = "scroll";
      // div.style.width = "50px";
      // div.style.height = "50px";
      // document.body.append(div);
      // const scrollWidth = div.offsetWidth - div.clientWidth;
      // console.log('scrollWidth: ', scrollWidth);
      // div.remove();
      document.body.style.overflow = isPopup ? "hidden" : "auto";
      // document.body.style.marginRight = isPopup ? scrollWidth + "px" : 0;
    },
    moreDescr(event){
      this.isMoreDescr = !this.isMoreDescr;     
    },

    openMenu() {
      this.show = !this.show;
      this.showLang = false;
      if (this.show) {
        document.querySelector("html").classList.add("hidden");
        document.querySelector("body").classList.add("hidden");
      } else {
        document.querySelector("html").classList.remove("hidden");
        document.querySelector("body").classList.remove("hidden");
      }
    },
    closedMenu() {
      this.show = false;
      if (this.show) {
        document.querySelector("html").classList.add("hidden");
        document.querySelector("body").classList.add("hidden");
      } else {
        document.querySelector("html").classList.remove("hidden");
        document.querySelector("body").classList.remove("hidden");
      }
    },
    coociesBtnBoom() {
      if (
        !this.cookieActive &&
        document.querySelector(".swiper-slide-active .cookies") !== null
      ) {
        this.cookieActive = true;
        this.activeSlide = this.swiperCookies.realIndex;
        let imgСookies = new Image();
        // Канвас для печенек

        let canvasСookies = document.querySelector(
          ".swiper-slide-active .cookies"
        );
        let ctxСookies = canvasСookies.getContext("2d");

        canvasСookies.width =
          150 * document.querySelector(".sizePage").dataset.number;
        canvasСookies.height =
          150 * document.querySelector(".sizePage").dataset.number;

        this.deleteAnimation = false;
        let num = 0;
        let numСookies = 0;

        let imgСookiesBoom = new Image();

        document.querySelector(".swiper-slide-active .cookies").style.height =
          window.innerHeight / 2 + "px";
        document.querySelector(".swiper-slide-active .cookies").height =
          window.innerHeight / 2;

        imgСookiesBoom.src = this.cookieSekvencia[
          this.cookieSekvencia.length - 1
        ].images;
        imgСookiesBoom.onload = function () {
          ctxСookies.clearRect(0, 0, canvasСookies.width, window.innerHeight);
          ctxСookies.drawImage(
            imgСookiesBoom,
            0,
            0,
            canvasСookies.width,
            window.innerHeight
          );
        };
        // Анимация разбиения печеньки
        let intervalСookies = () => {
          if (numСookies < this.cookieSekvencia.length - 5) {
            numСookies++;
            imgСookiesBoom.src = this.cookieSekvencia[numСookies].images;
            imgСookiesBoom.onload = function () {
              ctxСookies.clearRect(
                0,
                0,
                canvasСookies.width,
                window.innerHeight / 2
              );
              ctxСookies.drawImage(
                imgСookiesBoom,
                0,
                0,
                canvasСookies.width,
                window.innerHeight / 2
              );
              setTimeout(intervalСookies, 35);
            };
            imgСookiesBoom.onerror = function () {
              setTimeout(intervalСookies, 35);
            };
          } else {
            this.cookiesTextOn(this.activeSlide);
          }
        };
        intervalСookies();
      }
    },
    targetCooki() {
      if (!this.cookieActive) {
        this.cookieActive = true;
        this.activeSlide = this.swiperCookies.realIndex;

        this.deleteAnimation = false;
        let imgСookies = new Image();
        // Канвас для печенек

        let canvasСookies = document.querySelectorAll(".cookies")[
          this.activeSlide
        ];
        let ctxСookies = canvasСookies.getContext("2d");

        canvasСookies.width =
          150 * document.querySelector(".sizePage").dataset.number;

        let num = 0;
        let numСookies = 0;

        let imgСookiesBoom = new Image();

        canvasСookies.height = window.innerHeight / 2;

        imgСookiesBoom.src = this.cookieSekvencia[
          this.cookieSekvencia.length - 1
        ].images;
        imgСookiesBoom.onload = function () {
          ctxСookies.clearRect(0, 0, canvasСookies.width, window.innerHeight);
          ctxСookies.drawImage(
            imgСookiesBoom,
            0,
            0,
            canvasСookies.width,
            window.innerHeight
          );
        };

        // Анимация разбиения печеньки
        let intervalСookies = () => {
          if (numСookies < this.cookieSekvencia.length - 5) {
            numСookies = numСookies + 1;
            imgСookiesBoom.src = this.cookieSekvencia[numСookies].images;
            imgСookiesBoom.onload = function () {
              ctxСookies.clearRect(
                0,
                0,
                canvasСookies.width,
                window.innerHeight / 2
              );
              ctxСookies.drawImage(
                imgСookiesBoom,
                0,
                0,
                canvasСookies.width,
                window.innerHeight / 2
              );
              setTimeout(intervalСookies, 35);
            };
            imgСookiesBoom.onerror = function () {
              setTimeout(intervalСookies, 35);
            };
          } else {
            this.cookiesTextOn(this.activeSlide);
          }
        };
        intervalСookies();
      }
    },
    initCanvasСookies(imagePath, canvas, ctx, img) {
      img.src = imagePath;
      img.onload = function () {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      };
    },
    popapAnShow() {
      document.querySelectorAll(".cookies__prediction")[
        this.activeSlide
      ].style.opacity = 0;
      document
        .querySelectorAll(".cookies__prediction")
        [this.activeSlide].classList.remove("turn");
      setTimeout(() => {
        document
          .querySelectorAll(".cookies__prediction")
          [this.activeSlide].classList.remove("center");
        document
          .querySelectorAll(".cookies__prediction")
          [this.activeSlide].remove();
        document.querySelectorAll(".cookies")[this.activeSlide].remove();
        document.querySelectorAll(".cookies_swiper-slide")[
          this.activeSlide
        ].style.width = 0;
        document.querySelectorAll(".cookies_swiper-slide")[
          this.activeSlide
        ].style.marginRight = 0;
        setTimeout(() => {
          document
            .querySelectorAll(".cookies_swiper-slide")
            [this.activeSlide].remove();
        }, 500);
        this.deleteAnimation = true;
      }, 1000);
      this.popapShow = false;
      this.cookieActive = false;
      this.noScroll(this.popapShow);
      // document.querySelectorAll('.cookies__prediction')[this.activeSlide].remove()
      // document.querySelectorAll('.cookies_swiper-slide')[this.activeSlide].remove()
    },
    cookiesTextOn(i) {
      this.activeIndex = i;
      var canvasPaper = document.querySelectorAll(
        ".cookies__prediction__paper"
      )[this.activeIndex];
      var ctxPaper = canvasPaper.getContext("2d");

      canvasPaper.width =
        320 * document.querySelector(".sizePage").dataset.number;
      canvasPaper.height =
        106 * document.querySelector(".sizePage").dataset.number;

      let imgPaper = new Image();
      imgPaper.src = this.paperSekvencia[0].images;

      let num = 0;

      document
        .querySelectorAll(".cookies__prediction")
        [this.activeIndex].classList.add("center");

      let interval = () => {
        if (num < this.paperSekvencia.length - 1) {
          num++;
          imgPaper.src = this.paperSekvencia[num].images;
          imgPaper.onload = function () {
            ctxPaper.clearRect(0, 0, canvasPaper.width, canvasPaper.height);
            ctxPaper.drawImage(
              imgPaper,
              0,
              0,
              canvasPaper.width,
              canvasPaper.height
            );
            setTimeout(interval, 35);
          };
        } else {
          imgPaper.src = this.paperSekvencia[
            this.paperSekvencia.length - 1
          ].images;
          ctxPaper.drawImage(
            imgPaper,
            0,
            0,
            canvasPaper.width,
            canvasPaper.height
          );
        }
      };
      interval();

      setTimeout(() => {
        document
          .querySelectorAll(".cookies__prediction")
          [this.activeIndex].classList.add("turn");
        this.popapShow = true;
        this.noScroll(this.popapShow);
      }, 1000);
    },
    recipPopapInfoCard(a, b, c, i) {
      this.indexRecipes = i;
      this.recipesPopapShow = true;
      this.headPopap = b;
      this.textPopap = c;
      setTimeout(() => {
        document.querySelector(".new_popap__info img").setAttribute("src", a);
      }, 0);
      this.noScroll(this.recipesPopapShow);
    },
    closePopupRecip() {
      this.recipesPopapShow = false;
      this.noScroll(this.recipesPopapShow);
    },
    prevContentRecipes() {
      if (this.indexRecipes <= 0) {
        this.indexRecipes = this.recipes.length - 1;
      } else {
        this.indexRecipes = this.indexRecipes - 1;
      }
      this.headPopap = this.recipes[this.indexRecipes].title;
      this.textPopap = this.recipes[this.indexRecipes].text;
      setTimeout(() => {
        document
          .querySelector(".new_popap__info img")
          .setAttribute("src", this.recipes[this.indexRecipes].imges);
      }, 0);
    },
    leftRecipes() {
      if (this.indexRecipes <= 0) {
        this.indexRecipes = this.recipes.length - 1;
      } else {
        this.indexRecipes = this.indexRecipes - 1;
      }
      this.headPopap = this.recipes[this.indexRecipes].title;
      this.textPopap = this.recipes[this.indexRecipes].text;
      setTimeout(() => {
        document
          .querySelector(".new_popap__info img")
          .setAttribute("src", this.recipes[this.indexRecipes].imges);
      }, 0);
    },
    nextContentRecipes() {
      if (this.indexRecipes >= this.recipes.length - 1) {
        this.indexRecipes = 0;
      } else {
        this.indexRecipes = this.indexRecipes + 1;
      }
      this.headPopap = this.recipes[this.indexRecipes].title;
      this.textPopap = this.recipes[this.indexRecipes].text;
      setTimeout(() => {
        document
          .querySelector(".new_popap__info img")
          .setAttribute("src", this.recipes[this.indexRecipes].imges);
      }, 0);
    },
    rightRecipes() {
      if (this.indexRecipes >= this.recipes.length - 1) {
        this.indexRecipes = 0;
      } else {
        this.indexRecipes = this.indexRecipes + 1;
      }
      this.headPopap = this.recipes[this.indexRecipes].title;
      this.textPopap = this.recipes[this.indexRecipes].text;
      setTimeout(() => {
        document
          .querySelector(".new_popap__info img")
          .setAttribute("src", this.recipes[this.indexRecipes].imges);
      }, 0);
    },
    newsPopapInfoCard(a, b, c, i) {
      this.indexNews = i;
      this.newsPopapShow = true;
      this.headPopap = b;
      this.textPopap = c;
      setTimeout(() => {
        document.querySelector(".new_popap__info img").setAttribute("src", a);
      }, 0);
      this.noScroll(this.newsPopapShow);
    },
    closePopupNews() {
      this.newsPopapShow = false;
      this.noScroll(this.newsPopapShow);
    },
    prevContentNews() {
      if (this.indexNews <= 0) {
        this.indexNews = this.news.length - 1;
      } else {
        this.indexNews = this.indexNews - 1;
      }
      this.headPopap = this.news[this.indexNews].title;
      this.textPopap = this.news[this.indexNews].text;
      setTimeout(() => {
        document
          .querySelector(".new_popap__info img")
          .setAttribute("src", this.news[this.indexNews].imges);
      }, 0);
    },
    leftNews() {
      if (this.indexNews <= 0) {
        this.indexNews = this.news.length - 1;
      } else {
        this.indexNews = this.indexNews - 1;
      }
      this.headPopap = this.news[this.indexNews].title;
      this.textPopap = this.news[this.indexNews].text;
      setTimeout(() => {
        document
          .querySelector(".new_popap__info img")
          .setAttribute("src", this.news[this.indexNews].imges);
      }, 0);
    },
    nextContentNews() {
      if (this.indexNews >= this.news.length - 1) {
        this.indexNews = 0;
      } else {
        this.indexNews = this.indexNews + 1;
      }
      this.headPopap = this.news[this.indexNews].title;
      this.textPopap = this.news[this.indexNews].text;
      setTimeout(() => {
        document
          .querySelector(".new_popap__info img")
          .setAttribute("src", this.news[this.indexNews].imges);
      }, 0);
    },
    rightNews() {
      if (this.indexNews >= this.news.length - 1) {
        this.indexNews = 0;
      } else {
        this.indexNews = this.indexNews + 1;
      }
      this.headPopap = this.news[this.indexNews].title;
      this.textPopap = this.news[this.indexNews].text;
      setTimeout(() => {
        document
          .querySelector(".new_popap__info img")
          .setAttribute("src", this.news[this.indexNews].imges);
      }, 0);
    },
    popapActive(i) {
      this.indexInformation = i;
      this.prelastPopapShow = true;
      if (this.indexInformation <= 0) {
        this.prePopap = this.information[this.information.length - 1].title;
      } else {
        this.prePopap = this.information[this.indexInformation - 1].title;
      }
      if (this.indexInformation >= this.information.length - 1) {
        this.lastPopap = this.information[0].title;
      } else {
        this.lastPopap = this.information[this.indexInformation + 1].title;
      }

      this.headPopap = this.information[this.indexInformation].title;
      this.textPopap = this.information[this.indexInformation].textPopap;
      setTimeout(() => {
        this.imgPopap = this.information[this.indexInformation].imgPopap;
      }, 0);
      this.noScroll(this.prelastPopapShow);
    },
    closePopupPrelast() {
      this.prelastPopapShow = false;
      this.noScroll(this.prelastPopapShow);
    },
    prevContentPrelast() {
      if (this.indexInformation <= 0) {
        this.indexInformation = this.information.length - 1;
      } else {
        this.indexInformation = this.indexInformation - 1;
      }

      if (this.indexInformation <= 0) {
        this.prePopap = this.information[this.information.length - 1].title;
      } else {
        this.prePopap = this.information[this.indexInformation - 1].title;
      }

      if (this.indexInformation >= this.information.length - 1) {
        this.lastPopap = this.information[0].title;
      } else {
        this.lastPopap = this.information[this.indexInformation + 1].title;
      }

      this.headPopap = this.information[this.indexInformation].title;
      this.textPopap = this.information[this.indexInformation].textPopap;
      setTimeout(() => {
        this.imgPopap = this.information[this.indexInformation].imgPopap;
      }, 0);
    },
    leftPrelast() {
      if (this.indexInformation <= 0) {
        this.indexInformation = this.information.length - 1;
      } else {
        this.indexInformation = this.indexInformation - 1;
      }

      if (this.indexInformation <= 0) {
        this.prePopap = this.information[this.information.length - 1].title;
      } else {
        this.prePopap = this.information[this.indexInformation - 1].title;
      }

      if (this.indexInformation >= this.information.length - 1) {
        this.lastPopap = this.information[0].title;
      } else {
        this.lastPopap = this.information[this.indexInformation + 1].title;
      }

      this.headPopap = this.information[this.indexInformation].title;
      this.textPopap = this.information[this.indexInformation].textPopap;
      setTimeout(() => {
        this.imgPopap = this.information[this.indexInformation].imgPopap;
      }, 0);
    },
    nextContentPrelast() {
      if (this.indexInformation >= this.information.length - 1) {
        this.indexInformation = 0;
      } else {
        this.indexInformation = this.indexInformation + 1;
      }

      if (this.indexInformation <= 0) {
        this.prePopap = this.information[this.information.length - 1].title;
      } else {
        this.prePopap = this.information[this.indexInformation - 1].title;
      }

      if (this.indexInformation >= this.information.length - 1) {
        this.lastPopap = this.information[0].title;
      } else {
        this.lastPopap = this.information[this.indexInformation + 1].title;
      }

      this.headPopap = this.information[this.indexInformation].title;
      this.textPopap = this.information[this.indexInformation].textPopap;
      setTimeout(() => {
        this.imgPopap = this.information[this.indexInformation].imgPopap;
      }, 0);
    },
    rightPrelast() {
      if (this.indexInformation >= this.information.length - 1) {
        this.indexInformation = 0;
      } else {
        this.indexInformation = this.indexInformation + 1;
      }

      if (this.indexInformation <= 0) {
        this.prePopap = this.information[this.information.length - 1].title;
      } else {
        this.prePopap = this.information[this.indexInformation - 1].title;
      }

      if (this.indexInformation >= this.information.length - 1) {
        this.lastPopap = this.information[0].title;
      } else {
        this.lastPopap = this.information[this.indexInformation + 1].title;
      }

      this.headPopap = this.information[this.indexInformation].title;
      this.textPopap = this.information[this.indexInformation].textPopap;
      setTimeout(() => {
        this.imgPopap = this.information[this.indexInformation].imgPopap;
      }, 0);
    },
    // swipeProduct() {
    //     let topScroll = document.querySelector('.recipes').offsetTop - window.pageYOffset
    //     let topRange = window.pageYOffset
    //     setInterval(() => {
    //         if (topRange < document.querySelector('.recipes').offsetTop - 80) {
    //             window.scrollTo(pageXOffset, topRange += 5)
    //         }
    //     }, 0);
    // },
    perehod(a) {
      this.show = false;
      if (
        window.pageYOffset <
        document.querySelector("." + a.toLowerCase() + "").offsetTop
      ) {
        let topScroll =
          document.querySelector("." + a.toLowerCase() + "").offsetTop -
          window.pageYOffset;
        let topRange = window.pageYOffset;
        setInterval(() => {
          if (
            topRange <
            document.querySelector("." + a.toLowerCase() + "").offsetTop - 80
          ) {
            window.scrollTo(pageXOffset, (topRange += 15));
          }
        }, 0);
      } else if (
        window.pageYOffset >
        document.querySelector("." + a.toLowerCase() + "").offsetTop
      ) {
        let topScroll =
          window.pageYOffset -
          document.querySelector("." + a.toLowerCase() + "").offsetTop;
        let topRange = window.pageYOffset;
        setInterval(() => {
          if (
            topRange >
            document.querySelector("." + a.toLowerCase() + "").offsetTop - 80
          ) {
            window.scrollTo(pageXOffset, (topRange -= 15));
          }
        }, 0);
      }
    },
    shared(url) {
      if (url == "http://vkontakte.ru/share.php?") {
        url += "url=" + this.allCookies[this.activeIndex].htmlShare;
      } else if (url == "https://twitter.com/share?") {
        url += "url=" + this.allCookies[this.activeIndex].htmlShare;
      } else if (url == "https://connect.ok.ru/offer?") {
        url += "url=" + this.allCookies[this.activeIndex].htmlShare;
      } else if (url == "http://www.facebook.com/sharer.php?") {
        url += "u=" + this.allCookies[this.activeIndex].htmlShare;
      }
      window.open(url, "sharer", "toolbar=0,status=0,width=626,height=436");
    },
    transitionToCookies() {
      let topScroll =
        document.querySelector(".cookies__container").offsetTop -
        window.pageYOffset;
      let topRange = window.pageYOffset;
      setInterval(() => {
        if (
          topRange <
          document.querySelector(".cookies__container").offsetTop - 80
        ) {
          window.scrollTo(pageXOffset, (topRange += 15));
        }
      }, 0);
    },
  },
};
</script>
